export default {
  mobile: 1199
};
